'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');
var index = require('../SelectItem/index.js');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

const Item = styled__default["default"](index["default"]).withConfig({
  componentId: "sc-1rn0jmx-0"
})(["display:grid;grid-template-areas:", ";width:100%;grid-auto-flow:row;grid-template-columns:auto 1fr auto;align-items:center;justify-content:start;grid-column-gap:32px;grid-row-gap:5px;", ""], _ref => {
  let {
    selected
  } = _ref;
  return selected ? `'Icon Title Distance'
  'Icon Subtitle Distance'
  'Icon Address .'
  'Icon Details Details'` : `'Icon Title Distance'`;
}, _ref2 => {
  let {
    theme
  } = _ref2;
  return style.getFontSizing(theme.bodytextDefaultNone, {
    fontSize: '14px'
  });
});
const LocationItemIcon = styled__default["default"].div.withConfig({
  componentId: "sc-1rn0jmx-1"
})(["grid-area:Icon;grid-row:1 / -1;align-self:center;max-width:40px;display:grid;grid-auto-flow:column;gap:10px;"]);
const LocationItemTitle = styled__default["default"].div.withConfig({
  componentId: "sc-1rn0jmx-2"
})(["grid-area:Title;", " font-weight:700;text-align:left;color:inherit;"], _ref3 => {
  let {
    theme
  } = _ref3;
  return style.getFontSizing(theme.headersSmallNone, {
    fontSize: '14px'
  });
});
const LocationItemSubtitle = styled__default["default"].div.withConfig({
  componentId: "sc-1rn0jmx-3"
})(["grid-area:Subtitle;align-self:start;justify-self:start;text-align:left;color:inherit;"]);
const LocationItemHours = styled__default["default"].div.withConfig({
  componentId: "sc-1rn0jmx-4"
})(["grid-area:Details;color:", ";align-self:start;justify-self:start;text-align:left;display:grid;grid-auto-flow:column;gap:10px;"], _ref4 => {
  var _theme$text, _theme$text$color;
  let {
    theme
  } = _ref4;
  return (_theme$text = theme.text) === null || _theme$text === void 0 ? void 0 : (_theme$text$color = _theme$text.color) === null || _theme$text$color === void 0 ? void 0 : _theme$text$color.faded;
});
const LocationItemAddress = styled__default["default"].address.withConfig({
  componentId: "sc-1rn0jmx-5"
})(["grid-area:Address;font-style:normal;text-align:left;"]);
const LocationItemDistance = styled__default["default"].div.withConfig({
  componentId: "sc-1rn0jmx-6"
})(["grid-area:Distance;"]);

exports.Item = Item;
exports.LocationItemAddress = LocationItemAddress;
exports.LocationItemDistance = LocationItemDistance;
exports.LocationItemHours = LocationItemHours;
exports.LocationItemIcon = LocationItemIcon;
exports.LocationItemSubtitle = LocationItemSubtitle;
exports.LocationItemTitle = LocationItemTitle;
